import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'admin-dashboard-page',
    templateUrl: 'admin-dashboard.page.html',
    styleUrls: ['../../../layouts/admin/admin.layout.scss', 'admin-dashboard.page.scss'],
})
export class AdminDashboardPage implements OnInit {
    ngOnInit(): void {

    }
}